<!-- <h3>
  <span>{{item.translate | translate}}</span>
</h3> -->

<div>
  @for (item of item().children; track item.id) {
    @if (item.type === 'item') {
      <app-navigation-item [item]="item"></app-navigation-item>
    } @else if (item.type === 'group') {
      <app-navigation-group [item]="item"></app-navigation-group>
    } @else if (item.type === 'collapsable') {
      <app-navigation-collapsable [item]="item"></app-navigation-collapsable>
    } @else if (item.type === 'dashboard') {
      <!-- <app-dashboard-menu *ngIf="item.type === 'dashboard'" [item]="item"></app-dashboard-menu> -->
    }
  }

</div>
